import * as landRegistryActions from '../actions/landRegistry';
import * as landRegistryConstants from '../constants/landRegistry';
import landRegistryStore from '../stores/landRegistry';
import { LandRegistryLookupParts, LandRegistryLookupState } from '../typings/LandRegistryLookup';

const { events: landRegistryEvents } = landRegistryConstants;

/**
 * Fetch land registry data for the specific part of the land registry
 * @param landRegistryPartName {string} The part of the land registry to fetch
 * @param cadastreKey {string} The key for the property you want to fetch data for (cadastre or share key)
 * @param landRegistryPartState {string} The state of land registry you want to fetch (active or historical or both)
 */
export const retrieveLandRegistry = (
  landRegistryPartName: LandRegistryLookupParts,
  cadastreKey: string,
  landRegistryPartState: LandRegistryLookupState
): void => {
  landRegistryActions.retrieveLandRegistry(landRegistryPartName, cadastreKey, landRegistryPartState);
};

/**
 * Set the order reference to be used when ordering pantebok. Overrides query reference
 * @param orderReference {string} The order reference to use when ordering pantebok
 */
export const setOrderReference = (orderReference: string): void => {
  landRegistryActions.setOrderReference(orderReference);
};

/**
 * Register a new callback for a land registry lookup event
 * @param event {string} A land registry lookup event name
 * @param callback {Function} A callback function to register
 */
export function on(event: string, callback: (...args: any[]) => void) {
  if (event in landRegistryEvents) {
    landRegistryStore.on(landRegistryEvents[event], callback);
  } else {
    throw Error('Event ' + event + ' is not available');
  }
}

/**
 * Deregister a callback for a land registry lookup event
 * @param event {string} A land registry lookup event name
 * @param callback {Function} A callback function to deregister
 */
export function off(event: string, callback: (...args: any[]) => void) {
  if (event in landRegistryEvents) {
    landRegistryStore.off(landRegistryEvents[event], callback);
  } else {
    throw Error('Event ' + event + ' is not available');
  }
}
